import { Component, Inject, ViewContainerRef } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { Blog } from '../../models/blog/blog-model';
import { BlogCategory } from '../../models/blog/blog-category-model';
import { BlogCategoryService } from '../../services/blog/blog-category.service';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { BootstrapOptions } from '@angular/core/src/application_ref';
import { find } from 'rxjs/operator/find';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { CategoryService } from '../../services/category/category.service';

@Component({
  selector: 'app-blog-list',
  templateUrl: './blog-list.component.html',
  styleUrls: ['./blog-list.component.css']
})
/** blog-list component*/
export class BlogListComponent {
  /** blog-list ctor */
  public blogCategoryList: BlogCategory[];
  public blogList: Blog[];
  public searchKeyword: string;
  public blogStatus: string;
  public blogCategoryId: number;
  public websiteName: string;
  //Filter items from grid
  // blogStatus: any[];
  filteredItems: any[];
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
  constructor(private readonly blogService: BlogCategoryService, private readonly utilitiesService: UtilitiesService,
    public toastr: ToastsManager, vcr: ViewContainerRef, private readonly router: Router,
    private readonly rolePermissionService: RolePermissionService, private readonly categoryService: CategoryService) {
    this.rolePermissionService.GetRolePermissions("blog").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });
          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;
          if (list.length > 0) {
            this.toastr.setRootViewContainerRef(vcr);
            this.GetSystemSettingFirstOrDefault();
            this.GetBlogCategoryList();
            this.GetBlogList();
            //   this.GetBlogStatus();
            this.blogStatus = "";
            this.blogCategoryId = 0;
            this.GetRowsPerPageList();
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )

  }
  GetBlogCategoryList() {
    this.blogService.getBlogActiveCategory().subscribe(
      data => {
        this.blogCategoryList = data;
      }
    )
  }
  GetBlogStatus() {
    this.blogService.GetBlogStatus().subscribe(
      data => {
        this.blogStatus = data;
      }
    )
  }
  GetBlogList() {
    this.blogService.GetBlogs().subscribe(
      data => {
        this.blogList = data;

        this.filteredItems = data;
      }
    )
  }
  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  deleteBlog(id) {
    if (confirm("Are you sure to delete this blog ?")) {
      this.blogService.deleteBlog(id).subscribe(
        response => {
          if (response) {
            this.toastr.success('Blog has been Deleted.', 'Success');
            setTimeout(() => {
              this.GetBlogList();
            }, 2000);
          }
          else {
            this.toastr.error('Error occurred. Please try again', 'Success');
          }
        }
      )
    }
  }
  OnFilterChange() {
    this.filteredItems = this.blogList;
    if (this.searchKeyword != "" && this.searchKeyword != null) {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.filteredItems, this.searchKeyword);
    }

    if (this.blogStatus == "Pending" || this.blogStatus == "Draft" || this.blogStatus == "Published") {
      this.filteredItems = this.filteredItems.filter(s => s.blogStatus == this.blogStatus);

    }
    if (this.blogCategoryId > 0) {
      this.filteredItems = this.filteredItems.filter(s => s.blogCategoryId == this.blogCategoryId);

    }


  }
  GetSystemSettingFirstOrDefault() {
    this.categoryService.GetSystemSettingFirstOrDefault().subscribe(
      data => {
        if(data)
        this.websiteName = data.siteUrl + "/blog/";
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/blog-components/blog-list/blog-list.component.ts